import React from 'react';

import { AutoCompleteField, MCButton, TextField, View} from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { addressObject, lang, permissions, remCss, withRouter } from 'src/helpers';

import LANG_CONST from 'src/helpers/lang/const';
import model from './model';
import {FormRow} from "components/Form";

class PaymentDetails extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  save = (e) => {
    e.preventDefault();
    model.save();
  };
  cancel = (e) => {
    e.preventDefault();
    model.reset();
  };

  handleChange = (n, v) => {
    model.setStateSilent({ changed: true });
    model.resetApiState('update');
    model.handleChange(n, v);
  };

  render = () => {
    const { invalid, loading, ...createState } = model.getApiState('update');

    const address = addressObject(model.state);

    return (
      <div className={'mc-main-content'}>
        <form
          className={'mc-setting-payment-detail mc-flex-0-col'}
          style={{ height: '100%' }}
          onSubmit={this.save}
        >
          <div className={'mc-header'}>
            <div className={'mc-title'}>
              {lang.t(permissions.PAGES.SETTINGS_PAYMENT_DETAILS_PAGE.title)}
            </div>
          </div>
          <div className={'mc-grow mc-p30 mc-flex-25-col'}>
            <div className={'mc-flex-20-col'}>
              <FormRow >
                <TextField
                  template={6}
                  label={LANG_CONST.name}
                  name={'name'}
                  placeholder={''}
                  value={model.input('name')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow>
                <TextField
                  template={6}
                  label={LANG_CONST.payment.iban}
                  name={'iban'}
                  placeholder={''}
                  value={model.input('iban')}
                  onChange={(n, v) => {
                    if (v !== model.state.iban) model.ibanApi(v);
                    this.handleChange(n, v);
                  }}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow >
                <TextField
                  template={6}
                  label={LANG_CONST.address.address}
                  name={'address'}
                  placeholder={''}
                  value={model.input('address')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow >
                <AutoCompleteField
                  template={6}
                  label={LANG_CONST.address.country}
                  name={'countryAddress'}
                  value={model.input('countryAddress')}
                  onChange={(n, v) => {
                    if (model.input('countryAddress') !== v) {
                      this.handleChange(n, v);
                      this.handleChange('stateAddress', '');
                      this.handleChange('cityAddress', '');
                    }
                  }}
                  autocompleteApi='country'
                  autocompleteParams={{
                    limit: 300
                  }}
                  invalid={invalid}
                />
                <AutoCompleteField
                  template={6}
                  isOptional={true}
                  label={LANG_CONST.address.state}
                  name={'stateAddress'}
                  value={model.input('stateAddress')}
                  onChange={(n, v) => {
                    this.handleChange(n, v);
                    this.handleChange('cityAddress', '');
                  }}
                  invalid={invalid}
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    limit: 100
                  }}
                  autocompleteApi='state'
                />
                <AutoCompleteField
                  template={6}
                  isOptional={true}
                  label={LANG_CONST.address.city}
                  name={'cityAddress'}
                  value={model.input('cityAddress')}
                  onChange={(n, v) => {
                    this.handleChange(n, v);
                  }}
                  invalid={invalid}
                  autocompleteApi='city'
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    stateCode: address.stateCode,
                    limit: 20
                  }}
                />
              </FormRow>
              <FormRow>
                <TextField
                  template={6}
                  label={LANG_CONST.address.zip}
                  name={'zipcode'}
                  isOptional={true}
                  value={model.input('zipcode')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
                <View/>
                <View style={{justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                  <MCButton
                    type={'submit'}
                    medium
                    primary
                    radius
                    dark
                    disabled={loading}
                    loading={loading}
                    style={{width: remCss(100), marginTop: remCss(34)}}
                    label={LANG_CONST.buttons.save}
                  />
                </View>
              </FormRow>
            </div>
            <div className={'mc-value-620'}>{lang.t(LANG_CONST.titles.bank_details)}</div>
            <div className={'mc-flex-20-col'}>
              <FormRow addColspan={1}>
                <TextField
                  template={6}
                  label={LANG_CONST.payment.bank.name}
                  name={'bankName'}
                  placeholder={''}
                  isOptional={true}
                  value={model.input('bankName')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow addColspan={1}>
                <TextField
                  template={6}
                  isOptional={true}
                  label={LANG_CONST.payment.swift}
                  name={'swift'}
                  placeholder={''}
                  value={model.input('swift')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow addColspan={1}>
                <TextField
                  template={6}
                  isOptional={true}
                  label={LANG_CONST.payment.bank.address}
                  name={'bankAddress'}
                  placeholder={''}
                  value={model.input('bankAddress')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow>
                <AutoCompleteField
                  isOptional={true}
                  template={6}
                  label={LANG_CONST.payment.bank.country}
                  name={'bankCountryAddress'}
                  value={model.input('bankCountryAddress')}
                  onChange={(n, v) => {
                    if (model.input('bankCountryAddress') !== v) {
                      this.handleChange(n, v);
                      this.handleChange('bankStateAddress', '');
                      this.handleChange('bankCityAddress', '');
                    }
                  }}
                  autocompleteApi='country'
                  autocompleteParams={{
                    limit: 300
                  }}
                  invalid={invalid}
                />
                <AutoCompleteField
                  template={6}
                  label={LANG_CONST.payment.bank.state}
                  isOptional={true}
                  name={'bankStateAddress'}
                  value={model.input('bankStateAddress')}
                  onChange={(n, v) => {
                    this.handleChange(n, v);
                    this.handleChange('bankCityAddress', '');
                  }}
                  invalid={invalid}
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    limit: 100
                  }}
                  autocompleteApi='state'
                />
                <AutoCompleteField
                  template={6}
                  isOptional={true}
                  label={LANG_CONST.payment.bank.city}
                  name={'bankCityAddress'}
                  value={model.input('bankCityAddress')}
                  onChange={(n, v) => {
                    this.handleChange(n, v);
                  }}
                  invalid={invalid}
                  autocompleteApi='city'
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    stateCode: address.stateCode,
                    limit: 20
                  }}
                />
              </FormRow>
              <FormRow addColspan={2}>
                <TextField
                  template={6}
                  label={LANG_CONST.payment.revolut_id}
                  name={'revolutId'}
                  placeholder={''}
                  isOptional={true}
                  value={model.input('revolutId')}
                  onChange={this.handleChange}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
            </div>
          </div>
          {(model.state.changed || !model.state.user?.paymentDetails) && (
            <div className={'mc-b2t mc-flex mc-p30'}>
              {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
              <div className={'mc-grow'}></div>
              {!loading && (
                <MCButton
                  onClick={this.cancel}
                  medium
                  primary
                  radius
                  light
                  style={{width: remCss(100)}}
                  label={LANG_CONST.buttons.cancel}
                  disabled={loading}
                />
              )}
              <MCButton
                type={'submit'}
                medium
                primary
                radius
                dark
                disabled={loading}
                loading={loading}
                style={{width: remCss(100)}}
                label={LANG_CONST.buttons.save}
              />
            </div>
          )}
        </form>
      </div>
    );
  };
}

export default withRouter(PaymentDetails);
